module.exports = __webpack_public_path__ + "53bb24a5b249e1de45831b6fd6f186b4.png";